module.exports = __webpack_public_path__ + "static/media/icone-minhaClaro.181762e8.svg";